module.exports = __webpack_public_path__ + "img/xianlu.fc17c70d.png";